import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from 'src/app/service/common/auth-guard.service';
import { LayoutComponent } from './layouts/layout.component';
import { PrivacyPolicyComponent } from  './privacy-policy/privacy-policy.component';

const routes: Routes = [
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'login', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  // tslint:disable-next-line: max-line-length
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuardService]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
AuthGuardService